
import React from "react";
import { Layout } from "@/components/layout/Layout";
import { Users, Gift, Share2 } from "lucide-react";

const Partner = () => {
  return (
    <Layout>
      <div className="p-6">
        <h1 className="text-2xl font-semibold mb-4 flex items-center text-hossTeal">
          <Users className="mr-2 text-[#41c7f0]" size={24} />
          Partnerprogramm
        </h1>
        
        <div className="bg-[#0c0c0c] rounded-lg p-6 border border-gray-800 max-w-2xl">
          <div className="flex flex-col py-4">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 rounded-full bg-[#41c7f0]/10 flex items-center justify-center mr-4 border border-[#41c7f0]/30">
                <Gift className="text-[#41c7f0]" size={24} />
              </div>
              <div>
                <h2 className="text-xl font-semibold text-hossTeal">Empfehlen Sie uns weiter</h2>
                <p className="text-gray-400">Erhalten Sie Belohnungen für jede erfolgreiche Vermittlung</p>
              </div>
            </div>
            
            <div className="bg-[#081426] rounded-lg p-4 mb-6 border border-gray-700">
              <div className="flex justify-between items-center mb-3">
                <span className="text-gray-300">Ihr persönlicher Empfehlungslink</span>
                <button className="text-[#41c7f0] hover:text-[#3ab7de]">
                  <Share2 size={18} />
                </button>
              </div>
              <div className="bg-[#0c1525] p-3 rounded border border-gray-700 text-gray-400 text-sm">
                https://hoss-immo.de/ref/user12345
              </div>
            </div>
            
            <div className="bg-[#081426] rounded-lg p-4 border border-gray-700">
              <h3 className="font-medium mb-4 text-hossTeal">Empfehlungsstatistik</h3>
              <div className="flex flex-col gap-3">
                <div className="flex justify-between">
                  <span className="text-gray-400">Empfehlungen gesendet</span>
                  <span className="font-semibold text-white">3</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-400">Erfolgreiche Vermittlungen</span>
                  <span className="font-semibold text-white">1</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-400">Verdiente Provision</span>
                  <span className="font-semibold text-[#41c7f0]">€250,00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Partner;
